<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <PageHeader hero>
      <TextHeading variant="subtitle" color="secondary">Investor</TextHeading>
      <TextHeading variant="xl">Analysts</TextHeading>
    </PageHeader>
    <SubMenuMobile/>
    <PageGrid sidebar sharetools>
      <PageSide>
        <SideNav/>
        <KeyUpcomingDates/>
        <CardDownload title="Corporate Responsibility 2018/2019" shape="rectangle"/>
      </PageSide>
      <PageMain>
        <ShareLinksArticle desktop></ShareLinksArticle>
        <HeroImage></HeroImage>
        <TextProse>
          <h2>Wm Morrison Supermarkets PLC is covered by the analysts listed below.</h2>
          <p>Please note that any opinions, estimates or forecasts regarding Wm Morrison Supermarkets PLC's performance made by these analysts are theirs alone and do not represent opinions, forecasts or predictions of Wm Morrison Supermarkets PLC or its management. Wm Morrison Supermarkets PLC does not by its reference above or distribution imply its endorsement of or concurrence with such information, conclusions or recommendations.</p>
        </TextProse>
        <div class="accordion__header">Company</div>
        <TextAccordion :items="accordionItems"/>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import TheFooter from '../components/TheFooter.vue'
import TextAccordion from '../components/TextAccordion.vue'
import TextProse from '../elements/TextProse.vue'
import HeroImage from '../components/HeroImage.vue'
import ShareLinksArticle from '../components/ShareLinksArticle.vue'
import PageMain from '../elements/PageMain.vue'
import CardDownload from '../components/CardDownload.vue'
import KeyUpcomingDates from '../components/KeyUpcomingDates.vue'
import SideNav from '../components/SideNav.vue'
import PageSide from '../elements/PageSide.vue'
import PageGrid from '../elements/PageGrid.vue'
import SubMenuMobile from '../components/SubMenuMobile.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeader from '../components/PageHeader.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'InvestorsAnalysts',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageHeader,
    TextHeading,
    SubMenuMobile,
    PageGrid,
    PageSide,
    SideNav,
    KeyUpcomingDates,
    CardDownload,
    PageMain,
    ShareLinksArticle,
    HeroImage,
    TextProse,
    TextAccordion,
    TheFooter
  },
  data() {
    return {
      accordionItems: [
        {
          title: 'Bank of America',
          value:
            'James Anstead<br/>5 The North Colonnade,<br/>Canary Wharf,<br/>London<br/>E14 4BB<br/>T. 020 3134 6166',
          linktext: 'james.anstead@boa.com',
          link: 'mailto:james.anstead@boa.com'
        },
        {
          title: 'Barclays Capital',
          value:
            'Billy Barclay<br/>Head Office,<br/>High Street,<br/>London<br/>E1 5EE<br/>T. 020 3134 6166',
          linktext: '',
          link: ''
        },
        {
          title: 'Credit Suisse',
          value:
            'Mr Credit Suisse,<br/>Main HQ,<br/>Suisse Street,<br/>Bern Switzerland<br/>T. +44(0)20 3134 6166',
          linktext: 'mainhq@credit-suisse.com',
          link: 'mailto:mainhq@credit-suisse.com'
        }
      ]
    }
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>
<style lang="postcss">
.accordion__header {
  @apply p-6 font-semibold text-lg text-primary bg-secondary-lightest mb-2;
}
</style>